import type { RouteContext, RouterContext } from 'universal-router'
import type { RouterResponse } from '~/core/router'

/**
 * Router context type used by legacy route-depth helpers.
 */
export type Context = RouteContext<RouterResponse, RouterContext>

export type RouteData = {
  route: RouterResponse
}

export type RouteHistory = {
  module?: string | null
  routeName?: string | null
  categoryName?: string | null
}

export const DEFAULT = {
  module: null, // Module name 'Home' / 'Epg' ...
  routeName: null, // 'Extras' / 'Banners' ...
  categoryName: null, // 'Featured' / 'Movie' / ${categoryName} ...
}
